import _slicedToArray from "/home/technative/projects/signify/17thjuly/signify-app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export function objectUnzip(object) {
  var entries = Object.entries(object);
  var keys = entries.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      _ = _ref2[1];
    return key;
  });
  var values = entries.map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      _ = _ref4[0],
      value = _ref4[1];
    return value;
  });
  return [keys, values];
}
export function objectZip(keys, values) {
  var ret = {};
  keys.forEach(function (key, index) {
    ret[key] = values[index];
  });
  return ret;
}